<template>
  <div class="settings-page">
    <div class="settings-content">
      <div>
        <div data-testid="my-calendar.availability.back-to-calendar-btn" class="flex gap-2 cursor-pointer inline-flex" @click="goBack">
          <img src="@/assets/my-calendar/availability/arrow-left.svg" alt="Back" />
          <div class="back-font">Back to Calendar</div>
        </div>
      </div>
    
      <!-- Timezone Selector Section -->
      <div>
        <div class="card-title">Setup Time Zone</div>
        <div class="timezone-card">
          <SetupTimezoneCard />
        </div>
      </div>

      <div>
        <div class="card-title">Setup Your Scheduling Preferences</div>
        <div>
          <SetupSchedulingCard />
        </div>
      </div>

      <div>
        <div class="card-title">Setup Appointment Type</div>

        <SetupApptTypeCard />

      </div>
    </div>
  </div>
</template>

<script setup>
import SetupSchedulingCard from './SetupSchedulingCard.vue'
import SetupApptTypeCard from './SetupApptTypeCard.vue'
import SetupTimezoneCard from './SetupTimezoneCard.vue'
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { onMounted } from 'vue';

const router = useRouter();
const store = useStore();

const goBack = () => {
  router.push('/my-calendar');
}

onMounted(async () => {
  // try {
  //   // Fetch user settings when entering settings page
  //   const userSettings = await store.dispatch('calendar/getUserSettings');
  //   console.log('User settings loaded:', userSettings);
  // } catch (error) {
  //   console.error('Failed to fetch user settings:', error);
  // }
});
</script>


<style scoped>
.settings-page {
  display: flex;
  justify-content: center;
  width: 100%;
  background: #F9F9F9;
  padding: 36px 24px;
}

.settings-content {
  display: flex;
  flex-direction: column;
  gap: 32px;
  width: 100%;
  max-width: 1492px;
}

.card-title {
  font-weight: 600;
  font-size: 20px;
  font-family: 'Inter';
  line-height: 100%;
  letter-spacing: 0%;
  margin-bottom: 18px;
}

.timezone-card {
  background: white;
  padding: 40px;
  border-radius: 10px;
  box-shadow: 0px 1px 10px 0px rgba(74, 74, 74, 0.08);
}

.back-font{
  font-weight: 500;
  font-size: 18px;
  line-height: 22px;
  letter-spacing: 0.2px;
  color: #1E4670;
}
.back-font:hover{
  text-decoration: underline;
}

@media (max-width: 1024px) {
  .settings-page {
    padding: 24px 16px;
  }

  .settings-content {
    gap: 24px;
  }

  .timezone-card {
    padding: 24px;
  }
}

@media (max-width: 640px) {
  .settings-page {
    padding: 16px 12px;
  }

  .card-title {
    font-size: 18px;
    margin-bottom: 14px;
  }

  .timezone-card {
    padding: 16px;
    border-radius: 8px;
  }
}
</style>
